<template>
  <div class="container">
    <app-more title="社交动态" more="我有话说" link="https://s.weibo.com/weibo?q=%23%E9%98%B3%E5%85%89%E5%85%B3%E7%88%B1%C2%B7i%E8%AF%BB%E8%AE%A1%E5%88%92%23"></app-more>
    <div class="social-box">
      <div class="social-li" v-for="(s, i) of socialData" :key="i">
        <div class="left">
          <div class="year">{{s.date.split('-')[0]}}年</div>
          <div class="month">{{s.date.split('-')[1]}}月</div>
          <div class="day">{{s.date.split('-')[2]}}日</div>
        </div>
        <div class="right">
          <div class="top">
            <div class="img"><img :src="s.img" alt="" /></div>
            <div class="tit">
              <h3><a :href="s.link">{{s.title}}</a></h3>
              <p><a :href="s.link">{{s.description}}</a></p>
            </div>
          </div>
          <div class="des">
           <a :href="s.link">{{s.content}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import more from "../public/more.vue";
export default {
  data() {
    return {
      socialData:[]
    }
  },
  components: {
    "app-more": more
  },
  created() {
      this.$http.get('/Index/index/lists',{params:{name:'social',pi:1,ps:3}}).then(res=>{
      this.socialData = res.datas;
      
    })
   
  },
};
</script>
<style lang="less" scoped>
.social-box {
  //   border-bottom: 2px dotted #dcdcdc;
  display: flex;
  padding-bottom: 80px;
  justify-content: space-between;
  flex-wrap: wrap;
  // height: 420px;
  overflow: hidden;
  .social-li {
    cursor: pointer;
    &:hover {
      background-color: #fff;
    }
    background-color: #ecf3f4;
    margin-bottom: 50px;
    .top {
      //   display: flex;
      .img {
        float: left;
        width: 88px !important;
        height: 88px;
        margin-right: 10px;
        img {
          border-radius: 50%;
          width: 100%;
          height: 100%;
        }
      }
      .tit {
        flex: 1 0 auto;
        text-align: justify;
      }
      h3 {
        margin: 0 0 5px;
        font-size: 29px;
        font-weight: 400;
        a{
           text-align: justify;
          color: rgba(0, 0, 0, 1);
        }
        color: rgba(0, 0, 0, 1);
        opacity: 1;
      }
      p {
        margin: 0;
        font-size: 18px;
        font-weight: 100;
        line-height: 24px;
        a{
          color: rgba(0, 0, 0, 1);
        }
        color: rgba(0, 0, 0, 1);
      }
    }
    .des {
      font-size: 18px;
      margin-top: 15px;
      line-height: 26px;
       text-align: justify;
      a{
        color: rgba(0, 0, 0, 1);
      }
      color: rgba(0, 0, 0, 1);
    }
    width: 33%;
    border: 1px solid #dcdcdc;
    padding: 36px 20px;
    display: flex;

    border-radius: 5px;
    .left {
      width: 95px;
      height: 300px;
      border-right: 2px dotted #dcdcdc;
      .year {
        font-size: 14px;
        line-height: 14px;
      }
      .month {
        font-size: 26px;
        line-height: 26px;
      }
      .day {
        font-size: 30px;
        line-height: 30px;
      }
    }
    .right {
      padding: 0 0 0 20px;
      flex: 1 0 250px;
    }
  }
}
@media (max-width: 1640px) {
  .social-box {
    height:420px;
    .social-li {
      width: 49%;
    }
  }
}
@media (max-width: 922px) {
  .social-box {
    .social-li {
      width: 100%;
    }
  }
}
@media (max-width: 765px) {
  .social-box {
    padding: 0;
    height: auto;
  }
  .social-box {
   
    //   border-bottom: 2px dotted #dcdcdc;
    .social-li {
      margin-bottom:20px;
      .top {
        //   display: flex;
        .img {
          float: left;
          width: 66px !important;
          height: 66px;
          margin-right: 10px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .tit {
          flex: 1 0 auto;
        }
        h3 {
          margin: 0 0 5px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(0, 0, 0, 1);
          opacity: 1;
        }
        p {
          margin: 0;
          font-size: 12px;
          font-weight: 100;
          line-height: 18px;
          color: rgba(0, 0, 0, 1);
        }
      }
      .des {
        font-size: 12px;
        margin-top: 15px;
        line-height: 18px;
        text-align: justify;
        a{
           text-align: justify;
        }
        color: rgba(0, 0, 0, 1);
      }
      .left {
        width: 95px;
        height: auto;
        border-right: 2px dotted #dcdcdc;
        .year {
          font-size: 12px;
          line-height: 14px;
        }
        .month {
          font-size: 24px;
          line-height: 26px;
        }
        .day {
          font-size: 28px;
          line-height: 28px;
        }
      }
      .right {
        padding: 0 0 0 20px;
        flex: 1 0 250px;
      }
    }
  }
}
</style>